export const releases = [
  {
    date: "August 13, 2026",
    version: "v1.6.2",
    sections: [
      {
        tag: "Fixed",
        title: "More reliable data updates",
        items: [
          "Uploading new hospital data now works smoothly, even with files that previously caused errors.",
          "Fixed NPI number formatting issue.",
          "Updated the readmission reduction penalty score shown under facility details.",
        ],
      },
    ],
  },
  {
    date: "August 5, 2026",
    version: "v1.6.1",
    sections: [
      {
        tag: "Fixed",
        title: "Cancer cases data accuracy",
        items: [
          "Updated the data to correct discrepancies in the cancer cases data.",
          "Refreshed hospital data with the latest dataset (August 2026).",
        ],
      },
    ],
  },
  {
    date: "July 31, 2026",
    version: "v1.6.0",
    sections: [
      {
        tag: "Improved",
        title: "Partner ESA terminology & layout",
        items: [
          "Updated titles and labels across the Left and Right sections to use consistent 'Partner ESA' terminology.",
          "Refined the title block styles for a cleaner presentation.",
        ],
      },
    ],
  },
  {
    date: "July 20, 2026",
    version: "v1.5.0",
    sections: [
      {
        tag: "Improved",
        title: "Faster, cached data loading",
        items: [
          "Adopted React Query for app-wide API calls, adding response caching for faster, smoother loading.",
        ],
      },
    ],
  },
  {
    date: "July 14, 2026",
    version: "v1.4.0",
    sections: [
      {
        tag: "New",
        title: "Partner visibility",
        items: [
          "Added a partner icon across the app to make partner hospitals easy to spot.",
        ],
      },
      {
        tag: "Improved",
        title: "Fact sheet & labels",
        items: [
          "Overall rating now appears first in the fact sheet's Quality of Care section.",
          "Updated the Case Density title for clarity.",
        ],
      },
    ],
  },
  {
    date: "July 7, 2026",
    version: "v1.3.0",
    sections: [
      {
        tag: "New",
        title: "Stacked notifications & persistent search",
        items: [
          "Snackbar notifications now stack, so multiple messages can be viewed at once in a stacked layout.",
          "Search queries are now stored in the URL, preserving the query and results across page refreshes.",
        ],
      },
      {
        tag: "Improved",
        title: "Filtering & UI refinements",
        items: [
          "Refactored the Advanced Filter and related components for smarter search and filtering.",
          "Updated the Top 25 Hospitals title typography.",
        ],
      },
    ],
  },
  {
    date: "June 30, 2026",
    version: "v1.2.0",
    sections: [
      {
        tag: "New",
        title: "Cancer growth insights & richer hospital data",
        items: [
          "Added CBSA cancer growth rate to hospital details with a new growth chart on the fact sheet.",
          "Refreshed hospital data with the latest dataset (June 2026).",
        ],
      },
      {
        tag: "Improved",
        title: "Per-user bookmarks & data precision",
        items: [
          "Bookmarks are now per-user and require authentication, so each user sees only their own saved hospitals.",
          "Improved financial and patient-experience data precision in the hospital data model.",
        ],
      },
    ],
  },
  {
    date: "June 23, 2026",
    version: "v1.1.0",
    sections: [
      {
        tag: "Improved",
        title: "URL-driven filters & exports",
        items: [
          "Filters now live in the URL as the single source of truth, so they survive page reloads and can be shared via link.",
          "Updated the Advanced Filter UI and behaviour, including auto-restoring input values on page reload.",
          "Added the hospital website URL to the table view export.",
          "Table tooltips are now hidden when the cell text is already fully visible.",
        ],
      },
      {
        tag: "Fixed",
        title: "Partner ESA & counts",
        items: [
          "Fixed the total hospitals count when toggling Partner ESA, and hid the partner legend and badges when Partner ESA is excluded.",
          "The \"All Hospitals\" count now updates when quick filters change.",
        ],
      },
    ],
  },
  {
    date: "June 12, 2026",
    version: "v1.0.0",
    sections: [
      {
        tag: "New",
        title: "Authentication & session management",
        items: [
          "Introduced JWT-based authentication with access and refresh tokens for improved security.",
          "Implemented silent session restoration on app load, so users stay logged in without re-authenticating.",
          "Added dedicated login, logout, and token refresh routes for a seamless experience.",
          "Centralized frontend API calls through a single apiClient for consistent token and error handling.",
        ],
      },
      {
        tag: "New",
        title: "Partner ESA tracking & filters",
        items: [
          "Added partner presence to hospital summary responses for better ESA hospital tracking.",
          "Updated the Map view to match the new Figma design with a Partners exclusive filter.",
          "Added a combobox (combo mode) for Facilities and Locations with fixed option lists.",
          "Added an .xlsx export option, including styled Excel export for hospital comparisons.",
        ],
      },
      {
        tag: "Improved",
        title: "Map, table & layout refinements",
        items: [
          "Refreshed color scheme for low and high legends in the table and left section for clearer visuals.",
          "Smoothed the color gradient transition and switched scoring to a discrete color palette for readability.",
          "Updated map legend filter titles for both Map and Table views.",
          "Added a fixed-width content wrapper in the right section to keep layouts stable during transitions.",
          "Improved suggestion handling to always show complete option lists while typing.",
        ],
      },
      {
        tag: "Fixed",
        title: "Stability & data accuracy",
        items: [
          "Hexagon legend filter selection now persists across component remounts.",
          "Hospital counts by state now refetch correctly when navigating between views.",
          "Search now captures and restores the pre-search state when a search is cleared.",
          "Prevented UI flicker during table data refetching.",
          "Stopped tracking the backend .venv directory and refactored the formatPercentage helper.",
        ],
      },
    ],
  },
];
